import Vue from 'vue'
import VueKinesis from 'vue-kinesis'
import infiniteScroll  from 'vue-infinite-scroll'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { Slider, Checkbox, Tooltip, notification, Button, Dropdown, Menu, Icon, DatePicker, Tabs, Popover, Drawer, Affix, Input, Form, Select, Collapse} from 'ant-design-vue'
import {
    DropdownPlugin, ModalPlugin, CollapsePlugin, NavbarPlugin,
    CardPlugin, ButtonPlugin, TabsPlugin, TooltipPlugin, FormSelectPlugin,
} from 'bootstrap-vue'
import {
    MdField, MdButton, MdCheckbox, MdDatepicker,
    MdDialog, MdChips, MdAutocomplete, MdMenu,
} from 'vue-material/dist/components'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { KinesisContainer, KinesisElement} from 'vue-kinesis'
import VueMoment from 'vue-moment'
import VueCompositionAPI from '@vue/composition-api'
import VueAnalytics from 'vue-analytics'
import Fragment from 'vue-fragment'
import VueShepherd from 'vue-shepherd'
import 'ant-design-vue/lib/checkbox/style/index.css'
import 'ant-design-vue/lib/select/style/index.css'
import 'ant-design-vue/lib/slider/style/index.css'
import 'ant-design-vue/lib/tooltip/style/index.css'
import 'ant-design-vue/lib/message/style/index.css'
import 'ant-design-vue/lib/dropdown/style/index.css'
import 'ant-design-vue/lib/menu/style/index.css'
import 'ant-design-vue/lib/button/style/index.css'
import 'ant-design-vue/lib/icon/style/index.css'
import 'ant-design-vue/lib/notification/style/index.css'
import 'ant-design-vue/lib/date-picker/style/index.css'
import 'ant-design-vue/lib/tabs/style/index.css'
import 'ant-design-vue/lib/popover/style/index.css'
import 'ant-design-vue/lib/drawer/style/css'
import 'ant-design-vue/lib/affix/style/css'
import 'ant-design-vue/lib/input/style/css'
import 'ant-design-vue/lib/form/style/css'
import 'ant-design-vue/lib/collapse/style/css'
import 'shepherd.js/dist/css/shepherd.css'
import 'swiper/css/swiper.min.css'
import router from './router'
import store from './store'
import './firebase'
import App from './App.vue'
import {GA_ID} from "./constants";
import Mixpanel from './plugins/Mixpanel'
import VueLazyload from 'vue-lazyload'
import checkView from 'vue-check-view'
import lineClamp from 'vue-line-clamp'


Vue.use(VueLazyload)
Vue.use(checkView)
Vue.use(infiniteScroll)
Vue.use(VueAwesomeSwiper)
Vue.use(Slider)
Vue.use(Form)
Vue.use(Input)
Vue.use(Affix)
Vue.use(Drawer)
Vue.use(Tooltip)
Vue.use(Button)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Icon)
Vue.use(DatePicker)
Vue.use(Tabs)
Vue.use(Popover)
Vue.use(Select)
Vue.use(Checkbox)
Vue.use(notification)
Vue.use(TooltipPlugin)
Vue.use(CardPlugin)
Vue.use(ButtonPlugin)
Vue.use(DropdownPlugin)
Vue.use(FormSelectPlugin)
Vue.use(ModalPlugin)
Vue.use(CollapsePlugin)
Vue.use(NavbarPlugin)
Vue.use(TabsPlugin) 
Vue.use(MdField)
Vue.use(MdAutocomplete)
Vue.use(MdMenu)
Vue.use(MdButton)
Vue.use(MdCheckbox)
Vue.use(MdDatepicker)
Vue.use(MdDialog)
Vue.use(MdChips)
Vue.use(KinesisContainer)
Vue.use(KinesisElement)
Vue.use(Fragment.Plugin)
Vue.use(VueShepherd)
Vue.use(VueMoment)
Vue.use(VueCompositionAPI)
Vue.use(Collapse)
Vue.use(lineClamp, {
    importCss: true
})
Vue.use(VueAnalytics, {
    id: GA_ID[store.state.platform],
    router,
    debug: {
        sendHitTask: process.env.NODE_ENV === 'production'
    },
    trackEvent: true
})
Vue.use(Mixpanel)

Vue.config.productionTip = false
Vue.material.locale.dateFormat = 'dd/MM/yyyy'

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

if (process.env.NODE_ENV !== 'development') {
    const dsn = process.env.NODE_ENV === 'staging' ?
        'https://6e2151dea1974aa29bc5515d4db9fb81@o286397.ingest.sentry.io/5389388' :
        'https://13373af5fc1d4a24b00efd9e23bc2082@o286397.ingest.sentry.io/5272689';
    Sentry.init({
        dsn,
        integrations: [new VueIntegration({ Vue, attachProps: true })],
    })
}